import { DateTimePicker as MuiDateTimePicker } from "@material-ui/pickers";

const DateTimePicker = props => {
    return (
        <MuiDateTimePicker
            onKeyUp={e => {
                if (e.key !== "Enter" || e.target === null) return;
                e.target.click();
            }}
            {...props}
        />
    )
}

export default DateTimePicker